<template>
  <div>
    <div class="row pt-1">
      <div class="col-lg-12">
        <div class="tile-categorie-frame">
          <div class="tile-categorie">
            <div class="header">
              <div class="row">
                <div class="col-xl-6">
                  <span>{{ $t("global.pendingissues") }}</span>
                </div>
                <div class="col-xl-6 text-right pr-2">
                  <font-awesome-icon
                    icon="fa-solid fa-plus-circle"
                    style="cursor: pointer"
                    @click="neueAktivitaet"
                  />
                </div>
              </div>
            </div>
            <div class="body">
              <div class="row">
                <div class="mut-header-bg ml-0">
                  <div
                    class="mut-header pointer"
                    :class="{ 'mut-selected': activeHeadline === 2 }"
                    @click="setAllAssigned"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">{{
                        $t("global.assignedtome")
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="mut-header pointer"
                    :class="{ 'mut-selected': activeHeadline === 3 }"
                    @click="setAssignedToOthers"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">{{
                        $t("global.assignedtoothers")
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="mut-header pointer"
                    :class="{ 'mut-selected': activeHeadline === 4 }"
                    @click="setPersonal"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">{{
                        $t("global.personal")
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="mut-header pointer"
                    :class="{ 'mut-selected': activeHeadline === 1 }"
                    @click="setAllPending"
                  >
                    <div class="mut-headers">
                      <span class="primary-headline-text">{{
                        $t("global.notassigned")
                      }}</span>
                      <div class="red-dot" v-if="pendingCount">
                        {{ pendingCount }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 block belegliste br-t-l-0">
                  <b-table
                    ref="todoTable"
                    class="text-center"
                    thead-class="sticky-blue-bg"
                    tbody-tr-class="item p-1"
                    style="height: 320px"
                    responsive
                    hover
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-compare="sortDates"
                    :busy="pendenzenIsBusy"
                    show-empty
                    :items="aktivitaeten"
                    :fields="fields"
                    @row-dblclicked="aktivitaetOeffnen"
                  >
                    <template v-slot:cell(datum)="row">
                      <div class="datum" :class="datumColor(row.item)">
                        {{ row.item.geplantdatum }}
                      </div>
                    </template>
                    <template v-slot:cell(status)="row">
                      <div class="status" :class="statusBackground(row.item)">
                        {{ row.item.status.bezeichnung }}
                      </div>
                    </template>
                    <template #cell(details)="row">
                      <b-button
                        v-if="activeHeadline === 1"
                        @click="selbstzuweisung(row.item.id)"
                        variant="outline-primary"
                        size="sm"
                        v-tooltip="$t('global.assigntome')"
                        class="mr-3"
                      >
                        <font-awesome-icon icon="user-plus" />
                      </b-button>
                      <b-button
                        @click="row.toggleDetails"
                        class="m-0"
                        variant="outline-primary"
                        size="sm"
                        v-tooltip="$t('global.description')"
                      >
                        <font-awesome-icon
                          :icon="
                            row.detailsShowing
                              ? 'fa-chevron-up'
                              : 'fa-chevron-down'
                          "
                        />
                      </b-button>
                    </template>
                    <template #row-details="row">
                      <pre
                        class="text-left"
                        style="font-size:16px; font-family:'Open Sans', sans-serif;"
                        v-html="row.item.beschreibung || $t('global.nodescription')"
                      />
                    </template>
                    <template #table-busy>
                      <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </template>

                    <template #empty>
                      <div
                        v-if="pendenzenLadeFehler"
                        class="text-center text-danger my-2"
                      >
                        <strong>{{ $t("global.errorwhileloading") }}</strong>
                      </div>
                      <div
                        v-if="!pendenzenLadeFehler"
                        class="text-center text-primary my-2"
                      >
                        <strong>{{
                          $t("global.therearenopendingtodos")
                        }}</strong>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <aktivitaet-modal
      :isKontaktbasiert="true"
      :angemeldeterMitarbeiter="angemeldeterMitarbeiter"
      @aktivitaetCreated="aktivitaetErstellt"
      @aktivitaetChanged="aktivitaetGeaendert"
      @aktivitaetDeleted="aktivitaetDeleted"
      :pendenzenIsBusy="pendenzenIsBusy"
    />
  </div>
</template>

<script>
import Api from "@/api/Api";
import AppApi from "@/api/AppApi";
import store from "@/store";

import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
// import AktivitaetModal from "@/components/crm/AktivitaetModal";
import AktivitaetModal from "@/newviva/components/Modale/AktivitaetModalNewViva";
import page from "@/mixins/Page";
import AktivitaetService from "@/service/AktivitaetService";

export default {
  name: "StartseitePendenzenNewViva",
  components: { BSpinner, AktivitaetModal },
  store,
  mixins: [page],
  metaInfo() {},
  data() {
    return {
      pendenzenIsBusy: false,
      pendenzenLadeFehler: false,

      aktivitaeten: [],
      sortBy: "geplantdatum",
      sortDesc: false,
      activeHeadline: 2,
      pendingCount: null,
    };
  },
  created() {
    if (this.angemeldeterMitarbeiter) {
      this.getAktivitaeten();
    }

    this.countPending();
  },
  mounted() {
    this.$bus.$on("prozess-sidebar-reload", () => {
      this.countPending();
    });
  },
  watch: {
    angemeldeterMitarbeiter: function (val) {
      if (val) {
        this.getAktivitaeten();
      }
    },
  },
  computed: {
    fields() {
      return [
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.task"),
        },
        {
          key: "typ.bezeichnung",
          sortable: true,
          label: this.$t("global.type"),
        },
        {
          key: "datum",
          label: this.$t("global.dashboard_planneddate"),
          sortable: true,
          sortByFormatted: true,
          formatter: (value, key, item) => item.geplantdatum,
        },
        {
          key: "verantwortliche",
          label: this.$t("global.RESponsible"),
          sortable: true,
          sortByFormatted: true,
          formatter: (value, key, item) =>
            item.verantwortlicher.map((person) => person.personName).join(", "),
        },
        {
          key: "status",
          sortable: true,
          label: this.$t("global.status"),
        },
        {
          key: "details",
          sortable: false,
          label: "",
        },
      ];
    },
  },
  methods: {
    selbstzuweisung(id) {
      this.pendenzenIsBusy = true;

      AppApi.put(`zuweisung-aktivitaet/${id}`, [
        this.angemeldeterMitarbeiter.person.id,
      ])
        .then(() => {
          this.getAktivitaeten();
          this.$bus.$emit("prozess-sidebar-reload");
          this.pendenzenLadeFehler = false;

          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.movedactivity"),
          });
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.pendenzenLadeFehler = true;
        })
        .finally(() => {
          this.pendenzenIsBusy = false;
        });
    },
    getAktivitaeten() {
      this.pendenzenIsBusy = true;
      let params = {};

      if (this.activeHeadline === 1) {
        params.pendenzenmodus = "allpending";
      } else if (this.activeHeadline === 2) {
        params.pendenzenmodus = "allassigned";
      } else if (this.activeHeadline === 3) {
        params.pendenzenmodus = "assignedtoothers";
      } else if (this.activeHeadline === 4) {
        params.pendenzenmodus = "personal";
      }

      AppApi.get("aktivitaet/", { params })
        .then((response) => {
          this.aktivitaeten = response.data;
          params.pendenzenmodus === "allpending"
            ? (this.pendingCount = response.data.length)
            : "";
          this.pendenzenLadeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.pendenzenLadeFehler = true;
        })
        .finally(() => {
          this.pendenzenIsBusy = false;
        });
    },

    countPending() {
      this.pendenzenIsBusy = true;

      AppApi.get("aktivitaet/", { params: { pendenzenmodus: "allpending" } })
        .then((response) => {
          this.pendingCount = response.data.length;
          this.pendenzenLadeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.pendenzenLadeFehler = true;
        })
        .finally(() => {
          this.pendenzenIsBusy = false;
        });
    },

    neueAktivitaet() {
      let json = {
        person: this.ansprechpartner,
        neu: true,
      };
      this.$bus.$emit("aktivitaet-modal-show", json);
    },

    aktivitaetOeffnen(aktivitaet) {
      this.$bus.$emit("aktivitaet-modal-show", aktivitaet);
    },

    aktivitaetDeleted(aktivitaet) {
      AktivitaetService.deleteAktivitaet([aktivitaet.id], this);
    },

    aktivitaetErstellt(aktivitaet) {
      AktivitaetService.createAktivitaet(aktivitaet, this);
    },

    aktivitaetGeaendert(aktivitaet) {
      AktivitaetService.updateAktivitaet(aktivitaet, this);
    },

    setAllPending() {
      this.activeHeadline = 1;
      this.getAktivitaeten();
    },
    setAllAssigned() {
      this.activeHeadline = 2;
      this.getAktivitaeten();
    },
    setAssignedToOthers() {
      this.activeHeadline = 3;
      this.getAktivitaeten();
    },
    setPersonal() {
      this.activeHeadline = 4;
      this.getAktivitaeten();
    },
    statusBackground(item) {
      let status = item.status;

      if (status) {
        //Geplant:
        if (status.id == "17FD0A1A4A1") {
          return "statusWarn";
        }
        //Durchgeführt:
        else if (status.id == "17FD0A1BEE5") {
          return "statusSuccess";
        }
        //Abgesagt:
        else if (status.id == "17FD0A1E99E") {
          return "statusDanger";
        }
        // in Arbeit
        else {
          return "statusPrimary";
        }
      } else return "";
    },
    datumColor(datum) {
      //wenn datum oder datum.geplantdatum null ist, nichts returnen
      if (!datum || !datum.geplantdatum) return "";
      // Umwandeln des heutigen Datums in das numerische Format
      var today = ((date) => {
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        return (
          parseInt(year, 10) * 10000 +
          parseInt(month, 10) * 100 +
          parseInt(day, 10)
        );
      })(new Date());

      // Umwandeln von geplantdatum in das numerische Format für den Vergleich
      var datumNum = ((datumStr) => {
        const [day, month, year] = datumStr.split(".");
        return (
          parseInt(year, 10) * 10000 +
          parseInt(month, 10) * 100 +
          parseInt(day, 10)
        );
      })(datum.geplantdatum);

      if (datumNum < today) {
        return "pastDate";
      }
    },
  },
};
</script>

<style>
.red-dot {
  width: 15px;
  height: 15px;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  bottom: 20px;
  right: -4px;
  font-size: 10px;
  text-align: center;
  color: white;
  padding-top: 1px;
}
</style>